var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0431 5.44762H0.479116C0.385856 5.4474 0.294685 5.42043 0.216783 5.36997C0.138881 5.31952 0.0776362 5.24783 0.0405583 5.16363C0.00348079 5.07943 -0.00781755 4.9864 0.0080491 4.89598C0.0239157 4.80557 0.0662576 4.72165 0.129882 4.65458L4.25893 0.29962C4.34841 0.205272 4.4566 0.13 4.57683 0.0784621C4.69707 0.0269247 4.82678 0.000219599 4.95794 0H24.5209C24.6142 3.10185e-06 24.7055 0.0268373 24.7837 0.0772057C24.8616 0.127574 24.923 0.199283 24.9604 0.28352C24.9975 0.367757 25.0089 0.460855 24.9931 0.551375C24.9772 0.641895 24.9348 0.725893 24.8713 0.793046L20.7443 5.148C20.6546 5.2426 20.546 5.31802 20.4253 5.36958C20.3047 5.42113 20.1746 5.44768 20.0431 5.44762ZM20.7443 8.57578C20.6546 8.48118 20.546 8.40578 20.4253 8.35423C20.3047 8.30268 20.1746 8.2761 20.0431 8.27622H0.479116C0.385764 8.27622 0.294448 8.30304 0.216387 8.3534C0.138324 8.40376 0.076916 8.47547 0.0397069 8.55972C0.00249809 8.64398 -0.00889059 8.73703 0.00694011 8.82759C0.0227709 8.91809 0.0651315 9.0021 0.128817 9.06923L4.25893 13.4242C4.34841 13.5185 4.4566 13.5938 4.57683 13.6454C4.69707 13.6969 4.82678 13.7236 4.95794 13.7238H24.5209C24.6142 13.7238 24.7055 13.697 24.7837 13.6466C24.8616 13.5962 24.923 13.5245 24.9604 13.4403C24.9975 13.356 25.0089 13.263 24.9931 13.1724C24.9772 13.0819 24.9348 12.9979 24.8713 12.9308L20.7443 8.57578ZM24.8713 17.3455L20.7443 21.7004C20.6546 21.795 20.546 21.8704 20.4253 21.9219C20.3047 21.9735 20.1746 22.0001 20.0431 22H0.479116C0.385764 22 0.294448 21.9731 0.216387 21.9228C0.138324 21.8724 0.076916 21.8008 0.0397069 21.7165C0.00249809 21.6322 -0.00889059 21.5391 0.00694011 21.4486C0.0227709 21.3581 0.0651315 21.2741 0.128817 21.2069L4.25893 16.852C4.34841 16.7576 4.4566 16.6824 4.57683 16.6309C4.69707 16.5793 4.82678 16.5526 4.95794 16.5524H24.5209C24.6142 16.5524 24.7055 16.5792 24.7837 16.6296C24.8616 16.6799 24.923 16.7517 24.9604 16.8359C24.9975 16.9201 25.0089 17.0133 24.9931 17.1038C24.9772 17.1942 24.9348 17.2783 24.8713 17.3455Z",
    fill: "url(#paint0_linear_136_3321)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_3321",
    x1: 15.2117,
    y1: 31.399,
    x2: 32.2623,
    y2: 6.22771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.19cf4bb9a3765b5da49af2e12c6ddefc.svg";
export { ForwardRef as ReactComponent };